var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMimatic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DB3737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18V18.5H7.5V18H6.5ZM7 7V6.5H6.5V7H7ZM8 7L8.46724 6.822L8.34458 6.5H8V7ZM16 7V6.5H15.6554L15.5328 6.822L16 7ZM17 7H17.5V6.5H17V7ZM16.5 17.75V18.25H17.5V17.75H16.5ZM11.9066 17.2547L11.4393 17.4327L11.9066 17.2547ZM12.0934 17.2547L12.5607 17.4327L12.0934 17.2547ZM7.5 18V7H6.5V18H7.5ZM7 7.5H8V6.5H7V7.5ZM7.53276 7.178L11.4393 17.4327L12.3738 17.0767L8.46724 6.822L7.53276 7.178ZM12.5607 17.4327L16.4672 7.178L15.5328 6.822L11.6262 17.0767L12.5607 17.4327ZM16 7.5H17V6.5H16V7.5ZM16.5 7V17.75H17.5V7H16.5ZM11.4393 17.4327C11.6356 17.9479 12.3644 17.9479 12.5607 17.4327L11.6262 17.0767C11.757 16.7332 12.2429 16.7332 12.3738 17.0767L11.4393 17.4327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.75H19.25M4.5 14H19.25",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMimatic);
export default __webpack_public_path__ + "static/media/mimatic.1220323b329ed6a918262163b15085f2.svg";
export { ForwardRef as ReactComponent };